export const validObjectId: string = "5f63996918479b5124358137"
export const BIC = "DABAIE2D"
export const IBAN = "DE89 3704 0044 0532 0130 00"
export const VAT = "BG999999999"
export const phoneNumber = "+16502222323"
export const validPhoneNumber: string = "+16502222323"
export const validEmail: string = "max@gmx.de"
